import { message } from 'antd';
import { queryCache } from 'react-query';
import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { DbFolder } from '~src/types/db';
import { editFolder } from '~src/services/api';
import { updateCachedFolder } from '~src/services/cache/folders';
import { appLog } from '~src/utils/log';

type UseToggleFavouriteFolderReturn = {
  toggleFavouriteFolder: (folder: DbFolder) => Promise<void>;
};

/** Provides function for folder favourite toggle */
export const useToggleFavouriteFolder = (): UseToggleFavouriteFolderReturn => {
  const intl = useIntl();

  /** Toggle folder favourite prop */
  const toggleFavouriteFolder: UseToggleFavouriteFolderReturn['toggleFavouriteFolder'] = useCallback(
    async (folder: DbFolder) => {
      try {
        const folderId = folder.id;
        const nextIsFavourite = !folder.is_favorite;

        await editFolder({
          projectId: String(folder.project_id),
          folderData: {
            ...folder,
            is_favorite: nextIsFavourite,
          },
        });

        // to void dropdown stutter
        setTimeout(() => {
          updateCachedFolder(
            folderId,
            { is_favorite: nextIsFavourite },
            { projectId: String(folder.project_id) }
          );
          queryCache.invalidateQueries('folders');
        }, 200);
      } catch (err) {
        appLog('editFolder -> err', err);
        message.error(intl.formatMessage({ id: 'favourite-failed' }));
      }
    },
    [intl]
  );

  return { toggleFavouriteFolder };
};
